import { combineReducers } from 'redux';

import publicKey from './publickey.jsx'
import stoteCardDetail from './storecarddetail.jsx'
import secretQuesReducer from './secret_ques.jsx'
import getCardReducer from './getcardreducer.jsx'
import getProfileReducer from './getprofilereducer.jsx'
import getFriendsReducer from './getfriendsreducer.jsx'
import getPasswordReducer from './getpasswordreducer.jsx'
import getuseridReducer from './getuseridreducer.jsx'
import countryReducer from './countryreducer.jsx'
import Manage from './managesignin.jsx'
import getTransferHistory from './gettransferhistory.jsx'
import getAlertReducer from './getalertreducer.jsx'
import storeRowDetail from './storerowdetail.jsx'
import getCardActivityReducer from './getcardactivityreducer.jsx'
import selectedTabReducer from './selectedtabreducer.jsx'
import getValidIdReducer from './getvalididreducer.jsx'
import getactivationcardReducer from './getactivationcardReducer.jsx'
import getCardDetailsReducer from './carddetails.jsx'
import getUserIdInfoReducer from './getuseridinfo.jsx'
import getMobileNoInfoReducer from './getmobilenoinfo.jsx'
import customerListReducer from './customerlistreducer.js'
import getCardNoDetailsReducer from './cardnodetails'
export default combineReducers({
    publicKey,
    stoteCardDetail,
    secretQuesReducer,
    getCardReducer,
    getProfileReducer,
    getFriendsReducer,
    getPasswordReducer,
    getuseridReducer,
    countryReducer,
    Manage,
    getTransferHistory,
    storeRowDetail,
    getAlertReducer,
    getCardActivityReducer,
    selectedTabReducer,
    getValidIdReducer,
    getactivationcardReducer,
    getCardDetailsReducer,
    getUserIdInfoReducer,
    customerListReducer,
    getMobileNoInfoReducer,
    getCardNoDetailsReducer
})


// WEBPACK FOOTER //
// ./src/reducer/reducers.jsx